export const E_ACCOUNT_CHANGED = 'e_account_changed';
export const E_CHAIN_CHANGED = 'e_chain_changed';

export const E_LOGIN = 'e_login';

export const C_NEW_TX = 'c_new_tx';

export const C_TEST_FAILED = 'c_test_failed';
export const C_TEST_FINISHED = 'c_test_finished';
export const C_TEST_SUCCESS = 'c_test_success';

export const E_REJECT_SIGN = 'e_reject_sign';

export const E_NEW_BLOCK = 'e_new_block';

export const E_NEW_ORDER = 'e_new_order';